import type { Metric, MetricEntry } from '@/modules/scorecards/types';
import type { MetricThresholds } from '@/modules/workspaces/workspace-settings';

export function withEntry(
  entries: MetricEntry[],
  period: string,
  value: number | null,
): MetricEntry[] {
  const existing = entries.find((e) => e.period === period);
  if (existing) {
    return entries.map((e) => e.period === period ? { ...e, value } : e);
  }
  return [...entries, { period, value }];
}

export function entryTipsOffTrack(
  metric: Pick<Metric, 'targets' | 'origin'>,
  entries: MetricEntry[],
  period: string,
  thresholds: MetricThresholds,
): boolean {
  const activeTarget = metric.targets.find(
    (t) => (t.startPeriod === null || t.startPeriod <= period) && t.endPeriod === null
  ) ?? metric.targets.find(
    (t) => (t.startPeriod === null || t.startPeriod <= period) && (t.endPeriod === null || t.endPeriod >= period)
  );
  if (!activeTarget || activeTarget.orientation !== '>' || metric.origin !== 'input') return false;

  const sorted = [...entries].filter((e) => e.value != null).sort((a, b) => a.period.localeCompare(b.period));
  let consecutiveBad = 0;
  for (let i = sorted.length - 1; i >= 0; i--) {
    if (sorted[i].value! < activeTarget.target * (thresholds.successThreshold / 100)) consecutiveBad++;
    else break;
  }
  return consecutiveBad === thresholds.dangerZoneWeeks;
}
